import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import TooltipUI, {
  ArrowDirection,
} from 'hellospa/foundation/control/tooltip/tooltip-ui';
import Button, { ButtonType } from 'hellospa/foundation/control/button';
import * as types from 'hellospa/page/prep-and-send/data/types';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import styles from './index.scss';
import messages from './intl';
import classNames from 'classnames';
import AccessCode from './access-code';
import Attachments from './attachments';
import CloseIcon from './icons/close';
import {
  useField,
} from 'formik';

type Props = {
  index: number,
  recipient: types.Signer | types.Recipient
  showDeleteBtn: boolean,
  allowDelete: boolean,
  remove: () => void,
};

const ButtonsContainer = (props: Props) => {
  const parent = `recipients.${props.index}`;

  const intl = useIntl();
  const showAttachmentIcon = useSelector(selectors.showAttachmentIcon);

  // For non-Enterprise+ users, check to see if this account
  // can use access codes regardless of setting
  const allowAccessCode = useSelector(selectors.canAccessRecipientAccessCodes);

  const [, , attachmentsHelper] = useField<types.Attachment[]>(`${parent}.attachments`);
  const [, , accessCodeHelper] = useField<String>(`${parent}.accessCode`);

  return (
    <div className={styles.buttonsContainer}>
      {showAttachmentIcon && 'attachments' in props.recipient && (
        <span className={styles.buttonItem}>
          <Attachments
            parent={`recipients.${props.index}`}
            attachments={props.recipient.attachments}
            onClose={(attachments: types.Attachment[]) => {
              attachmentsHelper.setValue(attachments);
            }} />
        </span>
      )}
      {allowAccessCode && 'accessCode' in props.recipient && (
        <span className={styles.buttonItem}>
          <AccessCode
            parent={`recipients.${props.index}`}
            accessCode={props.recipient.accessCode}
            onClose={(accessCode: string) => {
              accessCodeHelper.setValue(accessCode);
            }} />
        </span>
      )}
      {props.showDeleteBtn && (<span className={styles.buttonItemClose}>
        <Button
          type="button"
          kind={ButtonType.Subtle}
          id={props.recipient.id}
          onClick={props.remove}
          className={classNames({
            [styles.invisible]: !props.allowDelete,
          })}
          data-qa-ref={`recipients.${props.index}.buttons.delete_row`}
        >
          <CloseIcon className={styles.closeIcon} />
          <span className={styles.closeTextButton}>
            {intl.formatMessage(messages.removeSigner)}
          </span>
          <TooltipUI className={styles.tooltip} arrow={ArrowDirection.Bottom}>
            {intl.formatMessage(props.recipient.type === types.RecipientTypes.Fax
              ? messages.removeRecipientTooltip
              : messages.removeSigner)}
          </TooltipUI>
        </Button>
      </span>)}
    </div>
  );
};

export default ButtonsContainer;
